import React from 'react';
const Wrap = (props) => {
    var _a;
    const addClasses = (_a = props.addClasses) !== null && _a !== void 0 ? _a : [];
    return (React.createElement("div", { className: "flex flex-col min-h-screen " + addClasses.join(' ') }, props.children));
};
export default Wrap;
